'use strict';

var CommonChars = require('../var/CommonChars');

var HALF_WIDTH_PERIOD = CommonChars.HALF_WIDTH_PERIOD;

function periodSplit(str) {
  return str.split(HALF_WIDTH_PERIOD);
}

module.exports = periodSplit;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/periodSplit.js
// module id = 143
// module chunks = 1